import { Deserializable } from '../../../models/protocols/deserializable';

export class BankAccount implements Deserializable {
  public id!: number;
  public memberId?: number;
  public nickname!: string;
  public institutionNumber!: string;
  public transitNumber!: string;
  public accountNumber!: string;
  public approvedPreAuthorizedDebit!: boolean;
  public active!: boolean;
  public createdDate!: string;
  public inUse: boolean = false;

  onDeserialize() {}
}
